// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.86.5/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"c18536af5f08e8ba0f72","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};